import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Strings } from 'src/app/enum/strings.enum';
import { 
  addDoc, collection, collectionData, deleteDoc, doc, endAt, 
  Firestore, getDoc, getDocs, limit, orderBy, query, setDoc, 
  startAt, updateDoc, where ,onSnapshot
} from '@angular/fire/firestore';
import { Auth, createUserWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail, signInWithEmailAndPassword, updateEmail, getAuth, getIdToken, fetchSignInMethodsForEmail } from '@angular/fire/auth';
import { ApiService } from '../api/api.service';
import { User } from 'src/app/models/user.model';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../global/global.service';

export class AuthUserId {
  constructor(public uid: string ) {}
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public static UNKNOWN_USER = null;
  private _uid = new BehaviorSubject<AuthUserId>(AuthService.UNKNOWN_USER!);

  env = environment.prefix;
  constructor(private global: GlobalService ,private storage: StorageService, private fireAuth: Auth, private apiService: ApiService, private firestore: Firestore) { }

  async login(email: string, password: string): Promise<any> {
    try {
      const response = await signInWithEmailAndPassword(this.fireAuth, email, password);
      // console.log(response);
      if(response.user) {
        console.log('User found')
        
        // const token = await (await this.fireAuth.currentUser).getIdToken();
        // console.log('token: ', token);
        const user: any = await this.getUserData(response.user.uid);
        // console.log('user',user)
        if(user.status== 'active') {
          // console.log('user 2',user)
          this.setUserData(response.user.uid);
          return user.status;
        } else {
          alert('User Deactivated')
          await this.logout();
          return false;
        }               
      }
    } catch(e) {
      throw(e);
    }
  }

  async getId() {
    const user = this._uid.value;
    // console.log('auth user id: ', user?.uid);
    if(user?.uid) {
      return user.uid;
    } else {
      return (await this.storage.getStorage(Strings.UID)).value;
    }
  }

  async updateEmail(oldEmail:any, newEmail:any, password:any) {
    // console.log(oldEmail, newEmail)
    try {
      const result = await signInWithEmailAndPassword(this.fireAuth, oldEmail, password);
      await updateEmail(result.user, newEmail);
    } catch(e) {
      console.log(e);
      throw(e);
    }
  }

  async logout() {
    try {
      await this.fireAuth.signOut();
      await this.storage.removeStorage(Strings.UID);
      this._uid.next(AuthService.UNKNOWN_USER!);
      return true;
    } catch(e) {
      throw(e);
    }
  }

  async getUserData(id:any) {
    // return (await (this.apiService.collection('users').doc(id).get().toPromise())).data();
    console.log(`${this.env}${environment.collections.VENDOR_USERS}/${id}`)
    const docSnap: any = await this.apiService.getDocById(`${this.env}${environment.collections.VENDOR_USERS}/${id}`);
      if(docSnap?.exists()) {
        return docSnap.data();
      } else {
        throw('No such document exists');
      }
  }

  

  setUserData(uid:any) {
    // console.log('setuser',uid)
    this.storage.setStorage(Strings.UID, uid);
    this._uid.next(new AuthUserId(uid));
  }

  async isBusinessNameTaken(businessName: string): Promise<boolean> {
    try {
      const collectionRef = collection(this.firestore, `${this.env}${environment.collections.VENDOR}`);
      const q = query(collectionRef, where('business_name', '==', businessName));
      const querySnapshot = await getDocs(q);
      return !querySnapshot.empty; // True if business name exists, false otherwise
    } catch (error) {
      console.error('Error checking business name:', error);
      throw error; // Re-throw to handle the error at a higher level
    }
  }


  async register(formValue: any, existing: boolean = false) {
    try {
      let currentUser;
  
      if (existing) {
        // Attempt to sign in existing user
        const userCredential = await signInWithEmailAndPassword(this.fireAuth, formValue.email, formValue.password1)
          .catch((error) => {
            console.error('Sign-in error:', error);
            // Return the error to the calling component
            throw error; 
          });
        currentUser = userCredential.user;
      } else {
        // Register new user
        const registeredUser = await createUserWithEmailAndPassword(this.fireAuth, formValue.email, formValue.password1)
          .catch(async (error) => {
            if (error.code === 'auth/email-already-in-use') {
              // Handle existing email
              return this.handleExistingEmail(formValue);
            } else {
              // Re-throw other errors
              throw error;
            }
          });
        
        currentUser = registeredUser.user;
      }
  
      const data = new User(
        currentUser.uid,
        formValue.email,
        formValue.phone,
        formValue.firstName,
        formValue.lastName,
        'active'
      );
  
      delete formValue.password1;
      delete formValue.password2;
      formValue.uid = currentUser.uid;
  
      // Create a promise for the API call
      // console.log('In Auth Service component',formValue)
      const apiCallPromise = new Promise<void>(async (resolve, reject) => {

        let endpoint = formValue.existingAccount ? environment.endpoints.QUERY_BANK_CUSTOMER : environment.endpoints.VENDOR;
        
        (await this.apiService.apiPost(formValue,endpoint)).subscribe({
          next: async (res) => {
            if (res['status'] === 'Success') {
              await this.setUserData(currentUser.uid);
              resolve(); // Resolve the promise when the API call is successful
            } else {
              console.log('Failed');
              reject('API call failed'); // Reject the promise if the API call fails
            }
          },
          error: (err) => {
            console.error('Error:', err.error.message);
            // this.global.showAlert(err.error.message.errorMessage, 'Registration Error');
            reject(err.error.message.errorMessage); // Reject the promise if there's an error in the subscription
          }
        });
      });
  
      // Await the promise to ensure the API call completes before continuing
      await apiCallPromise;
    } catch (e) {
      // Propagate the error back to the calling component
      throw e;
    }
  }

  
  async registerExistingUser(formValue: any) {
    try {
      delete formValue.password1;
      delete formValue.password2;
      
  
      // Await the apiPost call and handle subscription
      await new Promise<void>(async (resolve, reject) => {
        (await this.apiService.apiPost(formValue, environment.endpoints.VENDOR)).subscribe({
          next: async (res) => {
            if (res['status'] === 'Success') {
              // await this.setUserData(uid);
              resolve();
            } else {
              console.log('API call failed');
              reject('API call failed');
            }
          },
          error: (err) => {
            console.error('Error in subscription:', err);
            reject(err); // Properly propagate the error
          }
        });
      });
    } catch (e) {
      console.error('Caught error in registerExistingUser:', e);
      throw e; // Ensure the error is thrown to the caller of this function
    }
  }

  

  private async handleExistingEmail(formValue: any): Promise<any> {
    try {
      console.log('Handling existing email...');

      // Instead of using fetchSignInMethodsForEmail, call your backend API
      await this.apiService.apiAnonymousPost({ email: formValue.email }, environment.endpoints.CHECK_EMAIL).subscribe(
        response => {
          console.log('API response:', response);
          if (response['exists'] === true ) {
            // User exists in your system
            this.global.showAlert('An account with this email already exists.','Success!')
              // User is already a vendor
              return { status: 'Error', message: 'An account with this email already exists.' };
            
    
          } else {
            // User does not exist or there was an error
            return this.registerExistingUser(formValue);
          }
         
        },
        error => {
          console.error('Error calling API:', error);
          this.global.showAlert(error.error.message,'Oppps!!')
          
        }
      );



    } catch (error) {
      console.error('Error handling existing email:', error);
      throw error; 
    }
  }

  async updateVendor(formValue: any) {

    try {
        // Create a promise for the API call
        const apiCallPromise = new Promise<void>(async (resolve, reject) => {
          (await this.apiService.apiPatch(formValue, environment.endpoints.VENDOR )).subscribe({
            next: async (res) => {
              if (res['status'] === 'Success') {
                resolve(); // Resolve the promise when the API call is successful
              } else {
                console.log('Failed');
                reject('API call failed'); // Reject the promise if the API call fails
              }
            },
            error: (err) => {
              console.error('Error:', err);
              reject(err); // Reject the promise if there's an error in the subscription
            }
          });
        });
    
        // Await the promise to ensure the API call completes before continuing
        await apiCallPromise;

    } catch (e) {
      throw e;
    }

  }
  

  async resetPassword(email: string) {
    try {
      await sendPasswordResetEmail(this.fireAuth, email);
    } catch(e) {
      throw(e);
    }
  }

  checkAuth(): Promise<any> {
    return new Promise((resolve, reject) => {
      onAuthStateChanged(this.fireAuth, user => {
        // console.log('auth user: ', user);
        if(user){
          this._uid.next(new AuthUserId(user.uid))
        }
        resolve(user)
        // if(user) {
        //   this.setUserData(user.uid);         
        //   resolve(user.uid);
        // } else {
        //   // this.logout();
        //   reject(false);
        // }
      });
    });
  }

  async checkUserAuth() {
    try {
      const user = await this.checkAuth();
      if(user) {
        this.setUserData(user.uid);
        const profile: any = await this.getUserData(user.uid);
        if(profile) return profile.type;
        return false;
      } else {
        return false;
      }
    } catch(e) {
      throw(e);
    }
  }

  async updateVendorUser(profile) {
    try {
      const apiCallPromise = new Promise<void>(async (resolve, reject) => {
        (await this.apiService.apiPatch(profile, 'user')).subscribe({
          next: async (res) => {
            if (res['status'] === 'Success') {
              // await this.setUserData(registeredUser?.user?.uid);
              resolve(); // Resolve the promise when the API call is successful
            } else {
              console.log('Failed');
              reject('API call failed'); // Reject the promise if the API call fails
            }
          },
          error: (err) => {
            console.error('Error:', err);
            reject(err); // Reject the promise if there's an error in the subscription
          }
        });
      });
  
      // Await the promise to ensure the API call completes before continuing
      await apiCallPromise;
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  }


}
